<div>
    <footer class="black-bg text-white pt-5">
        <div class="container container-responsive mb-4 mt-4 pb-4">
            <div class="row mb-3">
                <div class="col-md-6 ">
                    <img src="assets/images/logos/skeinforce_logo_white_02.png" alt="Skeinforce Logo" height="40">
                    <div class="mt-3 footer-company-text">
                        <div class="mb-3">
                            <a href="https://skeinbim.com" target="_blank" rel="noopener noreferrer"
                                class="footer-link fs-16">SkeinBIM</a> |
                            <a href="https://skeinvision.com" target="_blank" rel="noopener noreferrer"
                                class="footer-link ms-1 fs-16">Skeinvision</a> |
                            <a href="https://skeingear.com" target="_blank" rel="noopener noreferrer"
                                class="footer-link ms-1 fs-16">Skeingear</a> |
                            <a href="https://business.skeinforce.com/" target="_blank" rel="noopener noreferrer"
                                class="footer-link ms-1 fs-16">Skeinforce</a>
                        </div>
                        <p class="mt-2 fs-16">
                            {{ 'group_divisions' | translate }}
                            <a href=" https://skeinholding.com"  target="_blank" rel="noopener noreferrer" class="footer-link fs-16">Skeinholding S.r.l.</a>
                        </p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="syne-text fs-25">{{ 'footer3' | translate }}</div>
                    <address class="fs-16 mt-2">
                        <a href="tel:+3903651921064" class="text-decoration-none footer-link d-block mb-1">
                            +39 0365 1921064
                        </a>
                        <a href="mailto:business@skeinforce.com" class="text-decoration-none footer-link d-block">
                            business&#64;skeinforce.com
                        </a>
                    </address>
                </div>

                <div class="col-md-3">
                    <div class=" d-flex justify-content-md-end">
                        <a href="https://business.skeinforce.com/" target="_blank" rel="noopener noreferrer"
                            class="btn btn-sm rounded-pill syne-text discover-btn fs-18 py-1 px-3 bg-dark">
                            {{ 'discover_skeinforce' | translate }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-end">

                <div class="d-flex gap-3">
                    <a href="https://www.facebook.com/skeinforce/" target="_blank" class="social-icon"><i
                            class="fab fa-facebook-f"></i></a>
                    <a href="https://www.instagram.com/skeinforce/" target="_blank" class="social-icon"><i
                            class="fab fa-instagram"></i></a>
                    <a href="https://www.linkedin.com/company/skeinforce/" target="_blank" class="social-icon"><i
                            class="fab fa-linkedin-in"></i></a>
                </div>
            </div>
            <hr class="border-top border-white opacity-100 border-2 my-2">
        </div>
        <div class="bg-white text-dark py-2">
            <div
                class="container container-responsive d-flex justify-content-center align-items-center gap-4 syne-text">
                <small>
                    Copyright
                    <a class="text-decoration-none company-link">Skeinholding S.r.l. Società Benefit</a>
                </small>
                <div class="d-none small d-md-flex gap-3">
                    <span class="text-dark text-decoration-none">{{ 'footer11' | translate }}</span>
                    <a class="ft-text text-dark text-decoration-none" routerLinkActive="active"
                        routerLink="/privacy-policy">{{ 'footer12' | translate }} </a>
                    <a class="ft-text text-dark text-decoration-none" routerLinkActive="active"
                        routerLink="/terms-of-use">{{'footer13' | translate }} </a>
                </div>
            </div>
        </div>
    </footer>
</div>